import { useState, useEffect } from "react";
import ApiConfig from "../services/ApiConfig";
import axios from "axios";

const GetEventSchedule = (eventId, environment) => {
    return new Promise(async (resolve, reject) => {
        try {
            const config = await ApiConfig();
            config.method = "get";
            config.url +=
                "/get_event_schedule?" +
                "environment=" +
                environment +
                "&event_id=" +
                eventId;
            const response = await axios(config);
            resolve(response.data);
        } catch (error) {
            reject(error.response ? error.response.data : "Failed to load event schedule");
        }
    });
};

const useGetEventSchedule = (eventId, environment) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [eventSchedule, setEventSchedule] = useState(null);

    const load = async (refetch) => {
        if (refetch) {
            setIsRefetching(true);
        }
        try {
            const response = await GetEventSchedule(eventId, environment);
            setIsLoaded(true);
            setEventSchedule(response);
        } catch (error) {
            setError(error);
        } finally {
            setIsRefetching(false);
        }
    };

    const refetchEventSchedule = () => load(true);

    useEffect(() => {
        load(false);
    }, []);

    return { eventSchedule, error, isLoaded, isRefetching, refetchEventSchedule };
};

export default useGetEventSchedule;
